module.exports = __webpack_public_path__ + "img/domain.e468ecd.png";